export const CHARGE_HISTORY_LOADING = 'CHARGE_HISTORY_LOADING';
export const CHARGE_HISTORY_SUCCESS = 'CHARGE_HISTORY_SUCCESS';
export const CHARGE_HISTORY_ERROR = 'CHARGE_HISTORY_ERROR';
export const CHARGE_HISTORY_LIMIT = 100;